





























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private currentData: any;
  @Watch("currentData", { immediate: true })
  private currentDataChange() {
    this.handleData();
  }
  @Prop()
  private visible: any;
  @Watch("visible", { immediate: true })
  private visibleChange() {
    this.ifLiangbiao = this.visible;
  }
  @Prop()
  private data: any;
  // private dataChange() {
  //   this.handleData();
  // }
  private ifLiangbiao: any = false;
  private leftCheckedAll: any = false;
  private rightCheckedAll: any = false;
  private liangbiaoTem: any = [
    // 随访数据的量表tab
    {
      name: "随访数据",
      label: "随访数据",
    },
  ];
  private leftData: any = {};
  private rightData: any = {};
  private handleData() {
    const arr: any = [];
    // 所有量表默认为未选中
    this.data.forEach((element: any) => {
      if (element.iv_name !== "通用" && element.iv_name !== "操作") {
        let d = JSON.parse(JSON.stringify(element));
        d.temp_list.forEach((ele: any) => {
          ele.checked = false;
          ele.hide = false;
        });
        arr.push(d);
      }
    });
    this.leftData = JSON.parse(JSON.stringify(arr));
    this.rightData = JSON.parse(JSON.stringify(arr));
    // 右边全部为隐藏状态
    this.rightData.forEach((element: any) => {
      element.temp_list.forEach((ele: any) => {
        ele.hide = true;
      });
    });
    // 已选择的需要在右边，并且禁用
    // 处理左边
    this.leftData.forEach((left: any) => {
      if (left.temp_list && left.temp_list.length > 0) {
        left.temp_list.forEach((leftEle: any) => {
          this.currentData.forEach((cur: any) => {
            cur.temp_list.forEach((curEle: any) => {
              if (leftEle.temp_id === curEle.temp_id) {
                // 改变左边数据
                leftEle.hide = true;
              }
            });
          });
        });
      }
    });
    // 处理右边
    this.rightData.forEach((right: any) => {
      if (right.temp_list && right.temp_list.length > 0) {
        right.temp_list.forEach((rightEle: any) => {
          this.currentData.forEach((cur: any) => {
            cur.temp_list.forEach((curEle: any) => {
              if (rightEle.temp_id === curEle.temp_id) {
                // 改变左边数据
                rightEle.hide = false;
                rightEle.disabled = true;
              }
            });
          });
        });
      }
    });
  }
  private openSave() {
    this.$emit("save", this.rightData);
  }
  private cancel() {
    this.$emit("cancel");
  }
  private isShowTitle(items: any) {
    let result = false;
    if (items.temp_list) {
      items.temp_list.forEach((ele: any) => {
        if (!ele.hide) {
          result = true;
        }
      });
    }
    return result;
  }
  private getNum(item: any) {
    let num = 0;
    if (item.length > 0) {
      item.forEach((element: any) => {
        if (element.temp_list && element.temp_list.length > 0) {
          element.temp_list.forEach((ele: any) => {
            if (!ele.hide) {
              num++;
            }
          });
        }
      });
    }
    return num;
  }
  private getCheckedNum(item: any) {
    let num = 0;
    if (item.length > 0) {
      item.forEach((element: any) => {
        if (element.temp_list && element.temp_list.length > 0) {
          element.temp_list.forEach((ele: any) => {
            if (!ele.hide && ele.checked) {
              num++;
            }
          });
        }
      });
    }
    return num;
  }
  private leftSelAll() {
    if (this.leftCheckedAll) {
      // 选中全部
      this.leftData.forEach((item: any) => {
        if (item.temp_list && item.temp_list.length > 0) {
          item.temp_list.forEach((ele: any) => {
            if (!ele.hide) {
              ele.checked = true;
            }
          });
        }
      });
      this.$forceUpdate();
    } else {
      // 取消全部选择
      this.leftData.forEach((item: any) => {
        if (item.temp_list && item.temp_list.length > 0) {
          item.temp_list.forEach((ele: any) => {
            if (!ele.hide) {
              ele.checked = false;
            }
          });
        }
      });
      this.$forceUpdate();
    }
  }
  private rightSelAll() {
    if (this.rightCheckedAll) {
      // 选中全部
      this.rightData.forEach((item: any) => {
        if (item.temp_list && item.temp_list.length > 0) {
          item.temp_list.forEach((ele: any) => {
            if (!ele.hide) {
              ele.checked = true;
            }
          });
        }
      });
    } else {
      // 取消全部选择
      this.rightData.forEach((item: any) => {
        if (item.temp_list && item.temp_list.length > 0) {
          item.temp_list.forEach((ele: any) => {
            if (!ele.hide) {
              ele.checked = false;
            }
          });
        }
      });
    }
  }
  private toLeft() {
    this.leftData.forEach((left: any) => {
      if (left.temp_list && left.temp_list.length > 0) {
        left.temp_list.forEach((leftEle: any) => {
          this.rightData.forEach((right: any) => {
            right.temp_list.forEach((rightEle: any) => {
              if (
                leftEle.temp_id === rightEle.temp_id &&
                !rightEle.hide &&
                rightEle.checked
              ) {
                // 改变左边数据
                leftEle.checked = false;
                leftEle.hide = false;
                // 改变右边数据
                rightEle.hide = true;
                rightEle.checked = false;
              }
            });
          });
        });
      }
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private toRight() {
    this.leftData.forEach((left: any) => {
      if (left.temp_list && left.temp_list.length > 0) {
        left.temp_list.forEach((leftEle: any) => {
          this.rightData.forEach((right: any) => {
            right.temp_list.forEach((rightEle: any) => {
              if (
                leftEle.temp_id === rightEle.temp_id &&
                !leftEle.hide &&
                leftEle.checked
              ) {
                // 改变右边数据
                rightEle.checked = false;
                rightEle.hide = false;
                // 改变左边数据
                leftEle.hide = true;
                leftEle.checked = false;
              }
            });
          });
        });
      }
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private mounted() {
    this.ifLiangbiao = this.visible;
    this.handleData();
  }
}
